<app-modal *ngIf="informationProperty" id="property-information-modal" [active]="showPropertyInformationModal" (modalClosed)="closeModal()">
  <div class="title is-4 has-text-centered is-bold" style="color: #35566E !important;">Objektinformationen</div>
  <div class="columns is-mobile">
    <div class="column is-two-third-tablet is-12-mobile">
      <div class="inputfield">
        <div class="is-bold">Name</div>
        <input readonly type="text" class="border-input" value="{{informationProperty.name}}"
               [ngStyle]="!informationProperty.name ? {'opacity':'0.2'} : {}"/>
      </div>
      <div class="columns is-mobile">
        <div class="column">
          <div class="columns is-variable is-mobile">
            <div class="column">
              <div class="inputfield">
                <div class="is-bold">Straße</div>
                <input readonly type="text" class="border-input"
                       value="{{informationProperty.street}}"
                       [ngStyle]="!informationProperty.street ? {'opacity':'0.2'} : {}"/>
              </div>
            </div>
            <div class="column  is-3 " style="width: 30%">
              <div class="inputfield">
                <div class="is-bold">Hausnummer</div>
                <input readonly type="text" class="border-input"
                       value="{{informationProperty.house_number}}"
                       [ngStyle]="!informationProperty.house_number ? {'opacity':'0.2'} : {}"/>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="columns is-variable is-1 is-mobile">
            <div class="column is-4">
              <div class="inputfield">
                <div class="is-bold">PLZ</div>
                <input readonly type="text" class="border-input "
                       value="{{informationProperty.zip}}"
                       [ngStyle]="!informationProperty.zip ? {'opacity':'0.2'} : {}"/>
              </div>
            </div>
            <div class="column is-8">
              <div class="inputfield">
                <div class="is-bold">Stadt</div>
                <input readonly type="text" class="border-input"
                       value="{{informationProperty.town}}"
                       [ngStyle]="!informationProperty.town ? {'opacity':'0.2'} : {}"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <hr>
  <div class="columns is-mobile" style="flex-wrap: wrap">
    <div *ngFor="let landregisterfolio of informationProperty.landregisterfolios" class="column is-6-tablet is-6-desktop is-12-mobile">
      <div class="columns is-mobile">
        <div class="column is-5-tablet is-5-desktop is-6-mobile">
          <div class="inputfield">
            <div class="is-bold">Grundbuchblatt</div>
            <input readonly type="text" class="border-input" value="{{landregisterfolio.number}}"
                   [ngStyle]="!landregisterfolio.number ? {'opacity':'0.2'} : {}">
          </div>
        </div>
        <div class="column is-6-tablet is-5-desktop is-5-mobile">
          <div class="inputfield">
            <div class="is-bold">Gemarkung</div>
            <input readonly type="text" class="border-input" value="{{landregisterfolio.gemarkung}}"
                   [ngStyle]="!landregisterfolio.gemarkung ? {'opacity':'0.2'} : {}">
          </div>
        </div>
      </div>
      <div *ngFor="let flur of landregisterfolio.flure" class="columns is-mobile">
        <div class="column is-4-tablet is-4-desktop is-6-mobile">
          <div class="inputfield">
            <div class="is-bold">Flur</div>
            <div style="display:flex; flex-direction: row;">
              <input readonly type="text" class="border-input" style="flex-grow: 2" value="{{flur.number}}"
                     [ngStyle]="!flur.number ? {'opacity':'0.2'} : {}">
            </div>
          </div>
        </div>
        <div class="column is-8-tablet is-8-desktop is-6-mobile">
          <div class="columns is-mobile" style="flex-wrap: wrap; width: 100%;">
            <div *ngFor="let flurstueck of flur.flurstuecke" class="column is-4">
              <div class="is-bold">Flstk</div>
              <div style="display: flex;flex-direction: row">
                <input readonly type="text" class="border-input" value="{{flurstueck.number}}"
                       [ngStyle]="!flurstueck.number ? {'opacity':'0.2'} : {}">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <hr *ngIf="showBillingAndBeneficiary">
  <div class="columns" *ngIf="showBillingAndBeneficiary">
    <div class="column">
      <div class="is-bold">Rechnungsempfänger</div>
      <input readonly class="border-input" value="{{informationProperty.billingAdress?.firma || ''}}"
             [ngStyle]="!informationProperty.billingAdress?.firma ? {'opacity':'0.2'} : {}">
      <div class="is-bold">Straße</div>
      <input readonly class="border-input" value="{{informationProperty?.billingAdress.street || ''}}"
             [ngStyle]="!informationProperty.billingAdress?.street ? {'opacity':'0.2'} : {}">
      <div class="columns">
        <div class="column">
          <div class="is-bold">PLZ</div>
          <input readonly class="border-input" value="{{informationProperty?.billingAdress.plz || ''}}"
                 [ngStyle]="!informationProperty.billingAdress?.plz ? {'opacity':'0.2'} : {}">
        </div>
        <div class="column">
          <div class="is-bold">Stadt</div>
          <input readonly class="border-input" value="{{informationProperty?.billingAdress.town || ''}}"
                 [ngStyle]="!informationProperty.billingAdress?.town ? {'opacity':'0.2'} : {}">
        </div>
      </div>
    </div>
    <div class="column">
      <div class="is-bold">Leistungsempfänger</div>
      <input readonly class="border-input" value="{{informationProperty.beneficiaryAddress?.firma || ''}}"
             [ngStyle]="!informationProperty.beneficiaryAddress?.firma ? {'opacity':'0.2'} : {}">
      <div class="is-bold">Straße</div>
      <input readonly class="border-input" value="{{informationProperty.beneficiaryAddress?.street || ''}}"
             [ngStyle]="!informationProperty.beneficiaryAddress?.street ? {'opacity':'0.2'} : {}">
      <div class="columns">
        <div class="column is-4">
          <div class="is-bold">PLZ</div>
          <input readonly class="border-input" value="{{informationProperty.beneficiaryAddress?.plz || ''}}"
                 [ngStyle]="!informationProperty.beneficiaryAddress?.plz ? {'opacity':'0.2'} : {}">
        </div>
        <div class="column">
          <div class="is-bold">Stadt</div>
          <input readonly class="border-input" value="{{informationProperty.beneficiaryAddress?.town || ''}}"
                 [ngStyle]="!informationProperty.beneficiaryAddress?.town ? {'opacity':'0.2'} : {}">
        </div>
      </div>
    </div>
  </div>
</app-modal>
